export default "__VITE_ASSET__BjyHvwoO__"